var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-statistic-container" },
    [
      _c(
        "div",
        { staticClass: "search-wrap", staticStyle: { position: "relative" } },
        [
          _c("div", { staticClass: "btn-group" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.topParams.type == 1 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(1)
                  }
                }
              },
              [_vm._v("昨日")]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.topParams.type == 2 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(2)
                  }
                }
              },
              [_vm._v("近7日")]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.topParams.type == 3 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(3)
                  }
                }
              },
              [_vm._v("近30日")]
            )
          ]),
          _c("el-date-picker", {
            staticStyle: { width: "240px", "margin-right": "12px" },
            attrs: {
              size: "mini",
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "统计时间",
              "end-placeholder": "统计时间",
              "picker-options": _vm.pickerOptions,
              clearable: ""
            },
            on: {
              change: function($event) {
                return _vm.selectTime($event, 1)
              }
            },
            model: {
              value: _vm.searchSelectTime,
              callback: function($$v) {
                _vm.searchSelectTime = $$v
              },
              expression: "searchSelectTime"
            }
          }),
          _c(
            "span",
            {
              staticClass: "tip",
              attrs: { slot: "reference" },
              slot: "reference"
            },
            [
              _vm._v("统计说明 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content:
                      "发送相关统计，受时间控件影响。统计所选时间内发送情况及转化情况。",
                    placement: "top"
                  }
                },
                [_c("i", { staticClass: "el-icon-question" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingTop,
              expression: "loadingTop"
            }
          ],
          staticClass: "card-wrap"
        },
        _vm._l(_vm.topDataList, function(item, index) {
          return _c("div", { key: index, staticClass: "card-item" }, [
            _c("img", {
              staticClass: "item-icon",
              attrs: { src: item.icon, alt: "" }
            }),
            _c("div", { staticClass: "item-data" }, [
              _c("div", { staticClass: "data-title" }, [
                _vm._v(_vm._s(item.text))
              ]),
              _c(
                "div",
                { staticClass: "data-num", style: { color: item.color } },
                [_vm._v(_vm._s(item.value))]
              )
            ])
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.lock",
              value: _vm.loadingZX,
              expression: "loadingZX",
              modifiers: { lock: true }
            }
          ],
          staticClass: "echart-container",
          staticStyle: { height: "367px", padding: "20px" }
        },
        [
          _vm.hasZX
            ? _c("div", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: { id: "zheXiangTu" }
              })
            : _c("div", { staticClass: "not-data" }, [_vm._v("暂无数据")])
        ]
      ),
      _c("div", { staticClass: "bar-chart-area" }, [
        _c("div", { staticClass: "chat-survey-wrap" }, [
          _c("div", { staticClass: "head-wrap" }, [
            _c("span", { staticClass: "title-name" }, [_vm._v("项目发送排行")]),
            _c(
              "span",
              {
                staticClass: "title-more",
                on: {
                  click: function($event) {
                    return _vm.chatClick("goods")
                  }
                }
              },
              [_vm._v("更多"), _c("i", { staticClass: "el-icon-arrow-right" })]
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingBar1,
                  expression: "loadingBar1"
                }
              ],
              staticClass: "echart-container"
            },
            [
              _vm.hasBar1
                ? _c("div", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { id: "chat-bar1" }
                  })
                : _c("div", { staticClass: "not-data" }, [_vm._v("暂无数据")])
            ]
          )
        ]),
        _c("div", { staticClass: "chat-survey-wrap" }, [
          _c("div", { staticClass: "head-wrap" }, [
            _c("span", { staticClass: "title-name" }, [_vm._v("活动发送排行")]),
            _c(
              "span",
              {
                staticClass: "title-more",
                on: {
                  click: function($event) {
                    return _vm.chatClick("act")
                  }
                }
              },
              [_vm._v("更多"), _c("i", { staticClass: "el-icon-arrow-right" })]
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingBar1,
                  expression: "loadingBar1"
                }
              ],
              staticClass: "echart-container"
            },
            [
              _vm.hasBar2
                ? _c("div", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { id: "chat-bar2" }
                  })
                : _c("div", { staticClass: "not-data" }, [_vm._v("暂无数据")])
            ]
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "table-filter" },
        [
          _c(
            "el-tag",
            {
              staticClass: "tree-input",
              attrs: {
                title: "选择员工",
                closable:
                  _vm.userIdListName && _vm.userIdListName.length === 0
                    ? false
                    : true,
                type: "medium",
                effect: "plain"
              },
              on: {
                close: _vm.searchCloseTag,
                click: function($event) {
                  return _vm.clickAddMember()
                }
              }
            },
            [
              _vm.userIdListName.length === 0
                ? _c("span", [_vm._v("选择员工")])
                : _vm._e(),
              _vm._l(_vm.userIdListName, function(item, index) {
                return _c("span", { key: index }, [
                  _vm._v(_vm._s(item.name)),
                  index != _vm.userIdListName.length - 1
                    ? _c("span", [_vm._v("、")])
                    : _vm._e()
                ])
              })
            ],
            2
          ),
          _c("el-date-picker", {
            staticStyle: { width: "240px" },
            attrs: {
              size: "mini",
              clearable: false,
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "picker-options": _vm.pickerOptions
            },
            on: {
              change: function($event) {
                return _vm.selectTime($event, 2)
              }
            },
            model: {
              value: _vm.searchSelectTime2,
              callback: function($$v) {
                _vm.searchSelectTime2 = $$v
              },
              expression: "searchSelectTime2"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-data" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingTable,
                  expression: "loadingTable"
                }
              ],
              ref: "singleTable",
              staticStyle: {
                width: "100%",
                height: "100%",
                "font-size": "13px"
              },
              attrs: {
                size: "medium",
                "header-cell-style": {
                  background: "#eef1f6",
                  color: "#606266"
                },
                "highlight-current-row": true,
                data: _vm.tableData,
                "default-sort": {
                  prop: "bindDangAnCount",
                  order: "descending"
                },
                height: "450px"
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "65", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.tableParams.size *
                                (_vm.tableParams.page - 1) +
                                (scope.$index + 1)
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "staffName",
                  label: "员工姓名",
                  "min-width": "88",
                  align: "center"
                }
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "sendNumber",
                    label: "发送总次数",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 发送总次数 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "指商品库中的商品和活动被发送的总次数",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "productSendNumber",
                    label: "商品发送次数",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 商品发送次数 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "指商品库中的商品类被发送的总次数",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "activitySendNumber",
                    label: "活动发送次数",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 活动发送次数 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "指商品库中的活动类链接被发送次数，包括领券活动，包括活动商品",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "productOpenNumber",
                    label: "商品打开次数",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 商品打开次数 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "指商品库中被发送的商品被客户点击的总次数",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "activityOpenNumber",
                    label: "活动打开次数",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 活动打开次数 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "指商品库中被发送的活动和活动商品被客户点击的总次数",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "registerNumber",
                    label: "引流新客数量数",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 引流新客数量数 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "指商品库中被发送的商品和活动带来的新客注册数量",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "orderTotalNumber",
                    label: "客户下单数量",
                    "min-width": "88",
                    align: "center"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 客户下单数量 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "客户通过客莱宝发送的商品&活动商品链接下单的数量",
                            placement: "top"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "staff-pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.tableParams.page,
              "page-size": _vm.tableParams.size,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "page-sizes": [20, 50, 100, 200, 500]
            },
            on: {
              "current-change": _vm.changePage,
              "size-change": _vm.changeSize
            }
          })
        ],
        1
      ),
      _c("StaffTree", {
        ref: "tree",
        attrs: {
          title: "选择成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: {
          closeTree: function($event) {
            _vm.dialogVisibleTree = false
          },
          clickSubmitTree: _vm.clickSubmitTree
        }
      }),
      _vm.showPopup
        ? _c("statisticsPopup", {
            ref: "statisticsPopup",
            on: { closePopup: _vm.closePopup }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }